import React from 'react';
import {FaArrowRight} from 'react-icons/fa';
import {IoOpen} from 'react-icons/io5';
import Img from 'gatsby-image';
import '../styles/global.scss';

export default function Landing(props) {
  // console.log(props);
  return (
    <div className="">
      <div className="container mx-auto w-full min-h-screen bg-white md:w-10/12 lg:w-11/12 lg:min-h-0 xl:w-10/12">
        <div className="flex flex-wrap justify-between mx-4 items-center min-h-screen md:mx-0 md:pt-32 lg:flex-nowrap lg:min-h-0 lg:py-40 xl:mx-8">
          <div>
            <div className="text-md text-gray-500 mb-8 uppercase mt-28 font-medium md:mt-0 lg:font-normal">
              {props.data.subtitle}
            </div>
            <div className=" text-4xl text-gray-700 font-semibold mb-16 md:font-bold md:text-7xl">
              {props.data.title}
            </div>
            <div className="flex flex-wrap gap-6 md:gap-12 md:flex-nowrap">
              <div className=" inline-block">
                <a
                  href="#my-projects"
                  className=" py-6 px-7 rounded-full uppercase shadow-secondary bg-about-primary text-white text-sm tracking-wide flex items-center relative focus:outline-none transition-all duration-500 transform hover:-translate-y-3"
                >
                  <span className=" mr-6 font-bold text-sm">
                                        Explore Works
                  </span>
                  <span className=" ">
                    <FaArrowRight />
                  </span>
                </a>
              </div>
              <div className=" inline-block">
                <a
                  href="/pdf/Resume_Aditya_Mudgil_(IIT Dhanbad).pdf"
                  // download
                  className=" py-6 px-7 rounded-full uppercase shadow-secondary bg-gray-400 text-white text-sm tracking-wide flex items-center relative focus:outline-none transition-all duration-500 transform hover:-translate-y-3"
                >
                  <span className=" mr-6 font-bold text-sm">
                                        Resume
                  </span>
                  <span className=" ">
                    <IoOpen />
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="overflow-hidden mix-blend-multiply object-cover w-full items-center my-12 md:my-0 lg:float-right lg:w-9/12">
            <Img fluid={props.data.img.childImageSharp.fluid} />
            {/* <img className="overflow-hidden object-cover w-full items-center my-12 md:my-0 lg:float-right lg:w-9/12" src="./image/Dummy.jpeg" alt="my photoo"/> */}
          </div>
        </div>
      </div>
    </div>
  );
}
